import React from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from 'rebass';

function RecordButton({ isRecording, isDisabled, isIOSUser, ...props }) {
  return (
    <Button
      variant="transparent"
      sx={{
        borderRadius: '50%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        opacity: isDisabled ? 0.5 : 1,
        transition: 'opacity .17s ease',
      }}
      type="button"
      disabled={isDisabled}
      p={0}
      {...props}
    >
      {/* {!isIOSUser && ( */}
      <Text color="white"
        fontFamily="Poppins"
        fontWeight={500}
        letterSpacing="-0.096px"
        fontSize={16}
        lineHeight="20px"
        p="10px 20px" sx={{
          borderRadius: '23px',
          background: '#9B59B6'
        }}
      >
        {isRecording ? 'End' : 'Start'} Recording
      </Text>
      {/* )} */}
    </Button>
  );
}

RecordButton.propTypes = { isRecording: PropTypes.bool.isRequired };

export default RecordButton;
